/* ET - LP Pill Nav: smooth-scrolls to the anchored section below the sticky header + bar and highlights
   the pill of the section currently in view (keeps it visible in the mobile swipe row). */
(function () {
  if (customElements.get('et-pill-nav')) return;

  class EtPillNav extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.et-lp-pill-nav__list');
      this.pills = Array.from(this.querySelectorAll('[data-et-pill-target]'));
      if (!this.list || this.pills.length === 0) return;

      /* --sticky-area-height is a calc() on :root, so its pixel value is read from a hidden probe of that height. */
      this.probe = document.createElement('span');
      this.probe.setAttribute('aria-hidden', 'true');
      this.probe.style.cssText = 'position:absolute;top:0;left:0;width:0;visibility:hidden;pointer-events:none;height:var(--sticky-area-height, 0px)';
      this.appendChild(this.probe);

      this.ticking = false;
      this.locked = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.activePill = this.querySelector('.et-lp-pill-nav__pill.is-active');
      this.onClick = this.onClick.bind(this);
      this.onScroll = this.onScroll.bind(this);

      this.addEventListener('click', this.onClick);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      clearTimeout(this.unlockTimer);
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    get section() {
      return this.closest('.shopify-section') || this;
    }

    /* Where a section should land: below the bar while it is sticky, otherwise right below the sticky header. */
    get offset() {
      const section = this.section;
      const style = getComputedStyle(section);
      if (style.position === 'sticky') return (parseFloat(style.top) || 0) + section.offsetHeight;
      return this.probe ? this.probe.getBoundingClientRect().height : 0;
    }

    targetFor(pill) {
      return document.getElementById(pill.dataset.etPillTarget);
    }

    onClick(event) {
      const pill = event.target.closest('[data-et-pill-target]');
      if (!pill) return;

      const target = this.targetFor(pill);
      if (!target) return;

      event.preventDefault();
      const top = target.getBoundingClientRect().top + window.scrollY - this.offset;
      this.setActive(pill);
      this.lockUntilScrollEnds();
      window.scrollTo({ top: Math.max(top, 0), behavior: this.scrollBehavior });
    }

    get scrollBehavior() {
      return this.reducedMotion.matches ? 'auto' : 'smooth';
    }

    /* Keep the clicked pill highlighted while the page scrolls past the other sections. */
    lockUntilScrollEnds() {
      const unlock = () => {
        if (!this.locked) return;
        this.locked = false;
        clearTimeout(this.unlockTimer);
        window.removeEventListener('scrollend', unlock);
        this.update();
      };

      this.locked = true;
      clearTimeout(this.unlockTimer);
      window.addEventListener('scrollend', unlock, { once: true });
      this.unlockTimer = setTimeout(unlock, 1200);
    }

    onScroll() {
      if (this.locked || this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        this.update();
      });
    }

    update() {
      const threshold = this.offset + 8;
      let current = this.pills[0];

      this.pills.forEach((pill) => {
        const target = this.targetFor(pill);
        if (target && target.getBoundingClientRect().top <= threshold) current = pill;
      });

      this.setActive(current);
    }

    setActive(pill) {
      if (!pill || pill === this.activePill) return;

      this.querySelectorAll('.et-lp-pill-nav__pill.is-active').forEach((active) => {
        active.classList.remove('is-active');
        active.removeAttribute('aria-current');
      });

      pill.classList.add('is-active');
      pill.setAttribute('aria-current', 'true');
      this.activePill = pill;

      if (this.list.scrollWidth > this.list.clientWidth) {
        const left = pill.offsetLeft - (this.list.clientWidth - pill.offsetWidth) / 2;
        this.list.scrollTo({ left: Math.max(left, 0), behavior: this.scrollBehavior });
      }
    }
  }

  customElements.define('et-pill-nav', EtPillNav);
})();
